// extracted by mini-css-extract-plugin
export default {"AppBody":"AppUI_AppBody__GkO6F","AppContent":"AppUI_AppContent__H8Y2m"};